import React from 'react';
import Link from 'next/link';
import Image from 'next/image';

const PHONE = '9492935721';
const PHONE_DISPLAY = '(949) 293-5721';
const SMS_LINK = `sms:${PHONE}`;
const CALL_LINK = `tel:+1${PHONE}`;

export default function Footer() {
  return (
    <footer
      style={{
        background: 'var(--mamba-graphite)',
        borderTop: '1px solid rgba(107,33,168,0.2)',
        padding: '64px 0 32px',
      }}
    >
      <div className="max-w-7xl mx-auto px-6">
        {/* Top row */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link href="/" className="flex items-center gap-3 mb-5">
              <div className="relative w-10 h-10 overflow-hidden rounded-sm">
                <Image
                  src="/assets/images/da1mamba-logo-1774498137711.png"
                  alt="DA1MAMBA Professional Detailing Logo"
                  fill
                  className="object-contain"
                />
              </div>
              <div>
                <div style={{ fontFamily: 'Manrope, sans-serif', fontWeight: 800, fontSize: '14px', letterSpacing: '0.1em', color: 'var(--white)', textTransform: 'uppercase' }}>
                  DA1MAMBA
                </div>
                <div style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '10px', letterSpacing: '0.12em', color: 'var(--mamba-gold-light)', textTransform: 'uppercase' }}>
                  Professional Detailing
                </div>
              </div>
            </Link>
            <p style={{ color: 'var(--gray-dim)', fontSize: '14px', lineHeight: '1.7', maxWidth: '320px', fontFamily: 'DM Sans, sans-serif' }}>
              Premium mobile detailing, paint correction, and ceramic coating for Newport Beach, Irvine, and all of Orange County.
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a
                href="https://www.instagram.com/da1mamba/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram @da1mamba"
                style={{ color: 'var(--gray-dim)', transition: 'color 0.2s' }}
                onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--white)')}
                onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--gray-dim)')}
              >
                <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                  <circle cx="12" cy="12" r="4"/>
                  <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor"/>
                </svg>
              </a>
              <a
                href="https://www.tiktok.com/@da1mamba"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="TikTok @da1mamba"
                style={{ color: 'var(--gray-dim)', transition: 'color 0.2s' }}
                onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--white)')}
                onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--gray-dim)')}
              >
                <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.76a4.84 4.84 0 0 1-1.01-.07z"/>
                </svg>
              </a>
              <a
                href="https://www.youtube.com/@da1mamba"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube @da1mamba"
                style={{ color: 'var(--gray-dim)', transition: 'color 0.2s' }}
                onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--white)')}
                onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--gray-dim)')}
              >
                <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <div className="label-gold mb-5">Navigation</div>
            <div className="flex flex-col gap-3">
              {[
                { label: 'Home', href: '/' },
                { label: 'Services', href: '/services' },
                { label: 'Gallery', href: '/gallery' },
                { label: 'About', href: '/about' },
              ]?.map((link) => (
                <Link
                  key={link?.href}
                  href={link?.href}
                  style={{ color: 'var(--gray-dim)', fontSize: '14px', fontFamily: 'DM Sans, sans-serif', transition: 'color 0.2s', textDecoration: 'none' }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--white)')}
                  onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--gray-dim)')}
                >
                  {link?.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <div className="label-gold mb-5">Contact</div>
            <div className="flex flex-col gap-3">
              <a
                href={CALL_LINK}
                style={{ color: 'var(--gray-dim)', fontSize: '14px', fontFamily: 'DM Sans, sans-serif', transition: 'color 0.2s', textDecoration: 'none' }}
                onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--white)')}
                onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--gray-dim)')}
              >
                {PHONE_DISPLAY}
              </a>
              <a
                href="mailto:info@da1mambadetailing.com"
                style={{ color: 'var(--gray-dim)', fontSize: '14px', fontFamily: 'DM Sans, sans-serif', transition: 'color 0.2s', textDecoration: 'none' }}
                onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--white)')}
                onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--gray-dim)')}
              >
                info@da1mambadetailing.com
              </a>
              <span style={{ color: 'var(--gray-dim)', fontSize: '14px', fontFamily: 'DM Sans, sans-serif' }}>
                Newport Beach, Irvine & OC
              </span>
              <a
                href="https://book.squareup.com/appointments/04o76ql3vbtxkz/location/LM68HVRDTDX7X/services"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'var(--mamba-purple-bright)', fontSize: '14px', fontFamily: 'DM Sans, sans-serif', transition: 'color 0.2s', textDecoration: 'none' }}
                onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--white)')}
                onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--mamba-purple-bright)')}
              >
                Book Online →
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div
          className="flex flex-col md:flex-row items-center justify-between gap-4 pt-8"
          style={{ borderTop: '1px solid rgba(107,33,168,0.15)' }}
        >
          <div className="flex flex-col sm:flex-row items-center gap-4">
            <p style={{ color: 'var(--gray-faint)', fontSize: '13px', fontFamily: 'DM Sans, sans-serif', textAlign: 'center' }}>
              © 2026 DA1MAMBA Professional Detailing. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <Link
                href="/privacy-policy"
                style={{ color: 'var(--gray-faint)', fontSize: '12px', fontFamily: 'DM Sans, sans-serif', transition: 'color 0.2s', textDecoration: 'none' }}
                onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--white)')}
                onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--gray-faint)')}
              >
                Privacy Policy
              </Link>
              <span style={{ color: 'rgba(107,33,168,0.4)', fontSize: '12px' }}>|</span>
              <Link
                href="/terms-of-service"
                style={{ color: 'var(--gray-faint)', fontSize: '12px', fontFamily: 'DM Sans, sans-serif', transition: 'color 0.2s', textDecoration: 'none' }}
                onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--white)')}
                onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--gray-faint)')}
              >
                Terms of Service
              </Link>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row items-center gap-4">
            <a
              href={SMS_LINK}
              className="btn-primary btn-sm"
            >
              Text for a Quote
            </a>
            <a
              href={CALL_LINK}
              style={{ color: 'var(--gray-dim)', fontSize: '13px', fontFamily: 'DM Sans, sans-serif', transition: 'color 0.2s', textDecoration: 'none' }}
              onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--white)')}
              onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--gray-dim)')}
            >
              {PHONE_DISPLAY}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}